module.exports = __webpack_public_path__ + "static/media/m-operator-video-001.b9b28d04.mp4";